import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { InvestorDeck } from './pages/InvestorDeck';
import { PitchDeck } from './pages/PitchDeck';
import { HallmarkDeck } from './pages/HallmarkDeck';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<PitchDeck data-id="element-3" />} data-id="element-2" />
        <Route path="/pilot" element={<PitchDeck data-id="element-5" />} data-id="element-4" />
        <Route path="/investor" element={<InvestorDeck data-id="element-7" />} data-id="element-6" />
        <Route path="/hallmark" element={<HallmarkDeck data-id="element-9" />} data-id="element-8" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-11" />} data-id="element-10" />
        <Route path="/terms" element={<TermsOfService data-id="element-13" />} data-id="element-12" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}